import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=061d8a94&scoped=true&"
import script from "./UserBlock.vue?vue&type=script&lang=js&"
export * from "./UserBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserBlock.vue?vue&type=style&index=0&id=061d8a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061d8a94",
  null
  
)

export default component.exports